import { makeAuthService } from '../../auth/auth-service-factory';
import { makeLogService } from '../../common/log/log/log-service-factory';
import { AttendantsImpl } from './attendants-impl';

export function makeAttendant() {
  return new AttendantsImpl(makeLogService(), makeAuthService());
}
